import React from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Avatar,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import MenuIcon from "@mui/icons-material/Menu";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const SoundsTableBody = ({ sounds, onDelete, onReorder }) => {
  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(sounds);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    onReorder(items);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="sounds-droppable">
        {(provided) => (
          <TableBody
            ref={provided.innerRef}
            {...provided.droppableProps}
            sx={{
              "& td, & th": {
                color: "#6A707E",
                fontWeight: 500,
                fontSize: "16px",
              },
            }}
          >
            {sounds.map((sound, index) => (
              <Draggable
                key={sound.id}
                draggableId={sound.id.toString()}
                index={index}
              >
                {(provided) => (
                  <TableRow
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    sx={{
                      backgroundColor: "white",
                      borderRadius: 2,
                      boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)",
                      "&:last-child td, &:last-child th": { borderBottom: 0 },
                    }}
                  >
                    <TableCell {...provided.dragHandleProps}>
                      <MenuIcon />
                    </TableCell>
                    <TableCell>
                      <Avatar
                        sx={{
                          bgcolor: "#6A707E",
                          width: 32,
                          height: 32,
                          fontSize: 16,
                          fontWeight: "bold",
                        }}
                      >
                        {sound.id}
                      </Avatar>
                    </TableCell>
                    <TableCell>{sound.file}</TableCell>
                    <TableCell>
                      <VolumeUpIcon w="24" h="24" />
                    </TableCell>
                    <TableCell>{sound.song}</TableCell>
                    <TableCell>{sound.artist}</TableCell>
                    <TableCell>{sound.length}</TableCell>
                    <TableCell>{sound.plays}</TableCell>
                    <TableCell>
                      <IconButton
                        color="error"
                        onClick={() => onDelete(sound.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </TableBody>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default SoundsTableBody;
